__turbopack_context__.v({
  "StandardPage": "sbIAWa_StandardPage",
});
